import { Wrapper } from './GlowBox.parts';
import type { GlowBoxProps } from './GlowBox.types';

export function GlowBox(props: GlowBoxProps) {
	const { glowBorderSize = 2, glowSize = 8 } = props;

	return (
		<Wrapper
			{...props}
			glowBorderSize={glowBorderSize}
			glowSize={glowSize}
			borderRadius={props.borderRadius}
		>
			{props.children}
		</Wrapper>
	);
}
